import { Component, Fragment, h } from '@stencil/core';

@Component({
  tag: 'livestream-screen',
  styleUrl: 'livestream-screen.scss'
})
export class LivestreamScreen {

  render() {
    return (
      <Fragment>
        <chapel-video
          autoplay
          bg="https://i.ytimg.com/vi/Oz6oOgM3fjA/hqdefault.jpg"
        ></chapel-video>
        <div class="overlay absolute top--0 bottom--0 left--0 right--0" />
        <div class="indicator absolute top--m left--m round--xs">LIVE</div>
        <div class="brand absolute row bottom--m left--m z--10 spacing--s align--center-v">
          <img
            class="logo"
            src="https://screens.chapel.at/assets/images/image01.png?v=fbea9e81"
          />
          <span>chapel.at</span>
        </div>
        <img
          class="qr z--10 absolute bottom--s right--s"
          src="https://screens.chapel.at/assets/images/image02.svg?v=38f03735"
        />
      </Fragment>
    )
  }
}
